export default __webpack_public_path__ + "static/media/notificationFilledIcon.d527d62f.svg";